/** Space above a sought transcript message, clear of the top fade and resize handle. */
const TRANSCRIPT_SCROLL_TARGET_OFFSET_PX = 32;

/** The scroll position that rests an element just below the top of its container, within the scrollable range. */
export function computeIdealScrollTopForElement(
  container: Element,
  element: Element,
): number {
  const maxScrollTop = Math.max(
    0,
    container.scrollHeight - container.clientHeight,
  );
  const elementTop =
    element.getBoundingClientRect().top -
    container.getBoundingClientRect().top +
    container.scrollTop;

  return Math.max(
    0,
    Math.min(elementTop - TRANSCRIPT_SCROLL_TARGET_OFFSET_PX, maxScrollTop),
  );
}

export function scrollToTranscriptElement(
  container: HTMLElement,
  element: Element,
): void {
  container.scrollTo({
    top: computeIdealScrollTopForElement(container, element),
    behavior: "smooth",
  });
}

export function findClosestScrollContainer(
  element: HTMLElement,
): HTMLElement | null {
  let ancestor: HTMLElement | null = element.parentElement;

  while (ancestor && ancestor.scrollHeight <= ancestor.clientHeight) {
    ancestor = ancestor.parentElement;
  }

  return ancestor;
}
